export const SET_PICK_A_SEAT_BEST_AVAILABLE_WARNING =
    'setPickASeatBestAvailableWarning';
export const CLEAR_PICK_A_SEAT_BEST_AVAILABLE_WARNING =
    'clearPickASeatBestAvailableWarning';
